export const TabNames = {
  DETAILS: "details",
  STYLE: "style",
  ADDITIONAL: "additional"
};

export const StyleOptions = {
  BLOCK_COLOR: "BLOCK_COLOR",
  BLOCK_BG: "BLOCK_BG",
  BLOCK_SIZE: "BLOCK_SIZE",
  BLOCK_NEGATIVE_MARGINS: "BLOCK_NEGATIVE_MARGINS",
  BLOCK_REMOVE_PADDING: "BLOCK_REMOVE_PADDING"
};

export const AdditionalOptions = {
  GENERAL: "GENERAL",
  VISIBILITY: "VISIBILITY"
};
